import { Text, VStack } from "@gluestack-ui/themed";
import Spinner from "@repo/core/components/core/Spinner";
import { useEffect } from "react";

export const BiometryFinished = () => {
  useEffect(() => {
    const mensagem = {
      status: "success"
    };
    window?.ReactNativeWebView?.postMessage(JSON.stringify(mensagem));
  }, []);

  return (
    <VStack
      flex={1}
      height="$100vh"
      width="100%"
      alignItems="center"
      justifyContent="center"
    >
      <VStack flex={1} flexGrow={1} alignItems="center" justifyContent="center">
        <Spinner />
        <Text mt="$4">Validando os dados</Text>
      </VStack>
      <Text></Text>
    </VStack>
  );
};
